import {
  store
} from 'Store/store';
import AppConfig from 'Constants/AppConfig';
import { chatApiService } from './chatApiService'

class FreshChatService {
  constructor(){
    this.initializeWidget.bind(this);
  }
  initializeWidget(
    restoreId,
    externalId,
    userProperties,
    widgetSettings
  ) {
    /**
     * window.fcWidget.isInitialized is check for the fcWidget is initialized or not,
     *     if fresh widget is already initalized, we need to destory the widget to re-initalize it.
     *
     * ex: If user has multiple bp ==> bp1 and bp2
     * If user is in bp1, fresh widget would have be initalized with bp1 restoreId
     * If user wants to switch to bp2, then we have to destory the bp1 fresh chat instance,
     * Once we have destroyed the bp1 fresh chat instance we can load the widget with new instance for bp 2 restoreId.
     */
    this.destoryWidget();

    window.fcWidget.on('unreadCount:notify', function (resp) {
      if (resp.count > 0) {
        store.dispatch('updateChatMessageCount', resp.count);
      }
    });

    window.fcWidget.on('widget:opened', async function () {
      store.dispatch('updateChatMessageCount', 0);
      // Store business name as firstname / freschat username as soon as business name it is updated by the user
      // window.fcWidget.user.get(function (resp) {
      //   var status = resp && resp.status;
      //   if (status == 200) {
      //     if (store.getters.businessName && (store.getters.businessName != resp.data && resp.data.firstName)) {
      //       self.updateUserProperties({
      //         firstName: `${store.getters.businessName}${store.getters.businessProfileId ? ` - ${store.getters.businessProfileId}` : '' }`
      //       });
      //     }
      //   }
      // });
    });

    /**
     * SetTime out is required because, fcWidget.destory would take some time to remove the instance old instance.
     */
    setTimeout(async () => {
      if (window.fcWidget.isInitialized() != true) {
        window.fcWidget.init({
          token: AppConfig.chatWindowToken,
          host: AppConfig.chatWindowUrl,
          externalId,
          restoreId,
          firstName: userProperties.firstName,
          email: userProperties.email,
          open: false,
          config: {
            cssNames: {
              widget: 'fc_frame',
              open: 'fc_open',
              expanded: 'fc_expanded'
            },
            fullscreen: false,
            headerProperty: widgetSettings.headerProperty,
            agent: {
              hideName: false,
              hidePic: false,
              hideBio: false
            },
            headers: {
              // eslint-disable-next-line
              push_notification: 'Don\'t miss out on any replies! Allow push notifications?',
              // eslint-disable-next-line
              channel_response: {
                offline: 'We are currently away. Please leave us a message',
                online: {
                  minutes: {
                    one: 'Currently replying in {!time!} minutes ',
                    more: 'Typically replies in {!time!} minutes'
                  },
                  hours: {
                    one: 'Currently replying in under an hour',
                    more: 'Typically replies in {!time!} hours'
                  }
                }
              }
            }
          }
        });
        var self = this;
        window.fcWidget.user.get(function (resp) {
          var status = resp && resp.status;
          if (status != 200) {
            self.updateUserProperties(userProperties);
          }
        });

        window.fcWidget.on('user:created', async function (resp) {
          var status = resp && resp.status,
            data = resp && resp.data;
          if (status === 200) {
            if (data.restoreId && data.externalId) {
              await chatApiService.storeChatIdentifiers(userProperties && userProperties.businessProfileId, data.restoreId, data.externalId);
            }
          }
        });
      }
    }, 1500);
  }

  updateUserProperties(user) {
    if (window && window.fcWidget) {
      window.fcWidget.user.setProperties(user);
    }
  }

  open() {
    window.fcWidget.open();
  }

  close() {
    window.fcWidget.close();
  }

  isOpen() {
    return window.fcWidget.isOpen();
  }

  destoryWidget() {
    if (window.fcWidget.isInitialized() == true) {
      window.fcWidget.user.clear().catch(() => {
        // If user doesn't exist it wont clear the user.
      });
      window.fcWidget.destroy();
    }
  }
}

export const freshChatService = new FreshChatService();